import template from './prems-discount-category-detail-restriction.html.twig';

Shopware.Component.register('prems-discount-category-detail-restriction', {
    template,

    props: {
        discountCategory: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },
});